<template>
    <div class="banner mt-3 py-3">

        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4 py-md-5 py-3 text-center ">
                    <p class="banner-count mb-0">10K+</p>
                    <p class="text-white mb-0">Project Completed</p>

                </div>
                <div class="col-12 col-md-4 py-md-5 py-3 text-center ">
                    <p class="banner-count mb-0">4,073</p>
                    <p class="text-white mb-0">Happy Customers</p>
                </div>
                <div class="col-12 col-md-4 py-md-5 py-3 text-center ">
                    <p class="banner-count mb-0">50</p>
                    <p class="text-white mb-0">Professional Worker</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'bannerComponent',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
    background-color: #363737;
}

.banner-count {
    color: #c69064;
    font-size: 32px !important;
    font-weight: bold;
}
</style>